import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'parcel',
    path: '/parcel',
    component: () => import('../pages/ParcelPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'parcelDetails',
    path: '/parcel/:parcelId',
    props: true,
    component: () => import('../pages/ParcelDetailsPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
